;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	//TODO::Yuri make refactoring base on steps.js files
	View.ClubsRegisterRecover = View.RegisterRecover.extend({
		// this view needs because the template must have the same name

	});

}(window, APP, Backbone, Marionette, $, _));